export const isObjectNotEmpty = (obj: Object) =>
  obj && JSON.stringify(obj) !== '{}';
